<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <h3 class="pl-3 pt-3 pb-2">{{ $t('Apply Bank Account') }}</h3>
                            <hr>
                            <div class="p-2 mb-4">
                                <div class="row mt-4">
                                    <div class="col-lg-4 col-md-12 pb-5">
                                        
                                        <div class="block-item p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center text-center">
                                                <div class="fz-20 fw-700 text-green">{{ $t('International') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Bank account') }}</span>
                                                </div>
                                            </div>
                                            
                                            <div class="fz-16 fw-600 mb-2">{{ $t('Account Type') }}</div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div class="number mr-2 op-5 bg-green">1</div>
                                                    <div>{{ $t('International') }}</div>
                                                </div>
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div class="mr-2 op-5">&nbsp;</div>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                            <button class="d-block btn text-white bg-green w-100 py-2" @click="applyNow('international')">{{ $t('Apply Now') }}</button>
                                        </div>

                                    </div>

                                    <div class="col-lg-4 col-md-12 pb-5">
                                        
                                        <div class="block-item p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center">
                                                <div class="fz-20 fw-700 text-red">{{ $t('Enterprise') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Bank account') }}</span>
                                                </div>
                                            </div>
                                            
                                            <div class="fz-16 fw-600 mb-2">{{ $t('Account Type') }}</div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div class="number bg-red mr-2">1</div>
                                                    <div>{{ $t('China Enterprise') }}</div>
                                                </div>
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div class="number bg-red mr-2">2</div>
                                                    <div>{{ $t('Hong Kong Enterprise') }}</div>
                                                </div>
                                            </div>
                                            <button class="d-block btn text-white bg-red w-100 py-2" @click="applyNow('enterprise')">{{ $t('Apply Now') }}</button>
                                        </div>

                                    </div>

                                    <div class="col-lg-4 col-md-12 pb-5">
                                        
                                        <div class="block-item p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center">
                                                <div class="fz-20 fw-700 text-blue">{{ $t('Individual') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Bank account') }}</span>
                                                </div>
                                            </div>
                                            <div class="fz-16 fw-600 mb-2">{{ $t('Account Type') }}</div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div class="number bg-blue mr-2 op-5">1</div>
                                                    <div>{{ $t('China Enterprise') }}</div>
                                                </div>
                                                <div class="d-flex align-items-center point mb-2">
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                            <button class="d-block btn text-white bg-blue w-100 py-2" @click="applyNow('individual')">{{ $t('Apply Now') }}</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
  
    export default {
        name: 'account-opening',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                stepList:["Select Bank Account","Account Type", "Information"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            applyNow(bank_account){
                if(bank_account == 'enterprise'){
                    this.$router.push({ 
                        path: 'account-type',
                        query: { 
                            bank_account:bank_account 
                        }
                    });
                }
                else if(bank_account == "individual"){
                    this.$router.push({ 
                        path: 'individual-account'
                    });
                }
                else{
                    this.$router.push({ 
                        path: 'international-company-information'
                    });
                }
            }
        },
        mounted(){
            
        }
    };
  </script>

<style>
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
</style>